
const typeEnumConst = {
	saleNum: 0,
	customerFlow: 1,
	turnoverRatio: 2,
	associatedPurchaseRate: 5,
};

export const message = {
	/**
* 常量
*/
'constant_yuan': '元', // 元
'constant_wan': '萬', // 常量萬
'constant_yi': '億', // 常量億
'constant_day': '日', // 日
'constant_week': '週', // 週
'constant_month': '月', // 月
'constant_month_short': '月', // 月
'constant_year': '年', // 年
'constant_quarter_short': '季', // 季
'constant_xiaoshoue': '銷售額', // 銷售額
'constant_liandailv': '連帶率', // 連帶率
'constant_kedanjia': '客單價', // 客單價
'constant_dingdanshu': '訂單數', // 訂單數
'constant_renxiao': '人效', // 人效
'constant_pingxiao': '坪效', // 坪效
'constant_keliu': '客流', // 客流
'constant_chengjiaolv': '成交率', // 成交率
'constant_jiandanjia': '件單價', // 件單價
'constant_mubiao': '目標', // 目標
'constant_quarter': '季度', // 季度
'constant_week_W': '週',
'constant_quarter_Q': '季度',
'constant_xiaoshoue_unit': '銷售額(元)', // 銷售額(元)
'constant_kedanjia_unit': '客單價(元/單)', // 客單價(元/單)
'constant_chengjiaolv_unit': '成交率(%)', // 成交率(%)
'constant_keliu_unit': '客流(人)', // 客流(人)
'constant_renxiao_unit': '人效(元/人)', // 人效(元/人)
'constant_pingxiao_unit': '坪效(元/平米)', // 坪效(元/平米)
'constant_jiandanjia_unit': '件單價(元/件)', // 件單價(元/件)
'constant_time': '時間', // 時間
'constant_tianqi': '天氣', // 天氣
'constant_no_data': '當前數據為空', // 無數據是顯示
'constant_all': '全部', // 全部
'constant_loading': '加載中...', // 加載中...
'constant_cancel': '取消', // 取消
'constant_confirm': '確定', // 確定
'constant_1month': '1月', // 1月
'constant_2month': '2月', // 2月
'constant_3month': '3月', // 3月
'constant_4month': '4月', // 4月
'constant_5month': '5月', // 5月
'constant_6month': '6月', // 6月
'constant_7month': '7月', // 7月
'constant_8month': '8月', // 8月
'constant_9month': '9月', // 9月
'constant_10month': '10月', // 10月
'constant_11month': '11月', // 11月
'constant_12month': '12月', // 12月
'constant_weixuanze': '未選擇', // 未選擇
'constant_start_time': '開始時間', // 開始時間
'constant_end_time': '結束時間', // 結束時間
'constant_tishi': '提示', // 提示
'constant_week_ri': '日', // 星期日
'constant_week_1': '一', // 星期1
'constant_week_2': '二', // 星期2
'constant_week_3': '三', // 星期3
'constant_week_4': '四', // 星期4
'constant_week_5': '五', // 星期5
'constant_week_6': '六', // 星期6
/**
* 主頁
*/
'homePage_dateTypeMap': [ // 首頁頭部模態框
{ value: 1, label: '今日', bannerLabel:"今日" },
{ value: 2, label: '本週', bannerLabel: "本週" },
{ value: 3, label: '本月', bannerLabel: "本月" },
{ value: 4, label: '本季度', bannerLabel :"本季度" },
{ value: 5, label: '今年', bannerLabel :"今年" },
	],
	'homePage_sale_array': [                       // 首頁頭部模態框
{ value: 1, label: '今日' },
{ value: 2, label: '本週' },
{ value: 3, label: '本月' },
{ value: 4, label: '本季度' },
{ value: 5, label: '今年' },
	],
	'homePage_tabList': [                           // 首頁tab列表
		{
value: typeEnumConst.saleNum,
label: '銷售額',
unit: '元',
		},
		{
value: typeEnumConst.customerFlow,
label: '客流',
unit: '人',
		},
		{
value: typeEnumConst.turnoverRatio,
label: '成交率',
unit: '%',
		},
		{
value: typeEnumConst.associatedPurchaseRate,
label: '連帶率',
unit: '',
		},
	],
'homePage_enterprise_overview': '企業概覽', // 企業概覽按鈕
'homePage_cycle_unset_top': '未設置', // 首頁圓環按鈕未設置時上面的字
'homePage_cycle_unset_bottom': '目標', // 首頁圓環按鈕未設置時下面的字
'homePage_this_month_sale': '本月銷售額', // 本月銷售額
'homePage_this_year_sale': '本年銷售額', // 本年銷售額
'homePage_noStoreAlertInfo': '對接銷售數據，了解企業經營動態，您還有{num}家門店尚未對接', //點擊感嘆號的彈出字
'homePage_the_average': '平均值', // 平均值
'homePage_alert_noMessage': '您還未導入相關銷售數據，您可以切換客流數據進行瀏覽，或者聯繫我們進行數據對接。撥打電話: ', // 彈出提示
'homePage_month_complete': '本月完成', // 完成情況本月完成
'homePage_year_complete': '本年完成', // 完成情況本年完成
'homePage_yichang_text': '{name}異常 請諮詢: 400-100-1392', // 異常顯示情況
'homePage_call_phone': '撥打電話', // 撥打電話
'homePage_zhengchang_text': '距平均：', // 正常情況顯示
'homePage_kanban': '看板', // 看板
'homePage_shaixuan': '篩選', // 篩選
'homePage_paiming': '排名', // 排名
	/**
* 區域概覽
*/
'stateMent_title_area': '區域概覽', // 頭部標題區域概覽
'stateMent_title_company': '企業概覽', // 頭部標題企業概覽
'stateMent_data_title': '核心數據', // 核心數據title
'stateMent_data_subtitle': '數據詳情', // 核心數據subtitle
'stateMent_indicator_tabList': [ // 時間tab
{
label: '今日',
value: 1,
},
{
label: '本週',
value: 2,
},
{
label: '本月',
value: 3,
		},
	],
'stateMent_sequential_fell': '環比下降', // 環比下降
'stateMent_sequential_rose': '環比增長', // 環比增長
'stateMent_chart_title': '客流與銷售額關聯分析', // 圖表分析title
'stateMent_sales_amount': '銷售數量', // 銷售數量
'stateMent_number_flow': '客流數', // 客流數
'stateMent_target_none': '銷售目標未配置', // 圖標目標未配置提醒
'stateMent_target_config': '立即配置', // 立即配置
'stateMent_title_storerank': '門店月銷售排名', // 門店月銷售排名
'stateMent_subtitle_storerank': '排名詳情', // 排名詳情
'stateMent_title_alarm': '告警消息', // 告警消息
'stateMent_subtitle_alarm': '消息列表', // 消息列表
'stateMent_no_storerank': '暫無排名', // 暫無排名
'stateMent_no_alarm': '暫無告警信息', // 暫無告警信息
'stateMent_find_detail': '了解詳情', // 了解詳情
	/**
* 銷售目標
*/
'saleTarget_saleTarget_config_title': '銷售目標配置', // 銷售目標配置
'saleTarget_save_target': '保存配置', // 保存配置
'saleTarget_name_title': '{name}年銷售目標', // 門店名加時間的title
'saleTarget_last_year_sale': '上年銷售額', // 上年銷售額
'saleTarget_money_units': ["元", "萬元", "億元", "萬億"], // 單位
'saleTarget_danwangji': '淡旺季權重分配', // 淡旺季權重分配
'saleTarget_now_target': '當前目標數據：', // 當前目標數據
'saleTarget_target_poor': '於年目標相差：', // 於年目標相差
'saleTarget_table_head': ['季度','目標數據（萬）','上年參考（萬）'], // table的表頭
'saleTarget_area_config': '區域權重分配', //區域權重分配
'saleTarget_average_btn': '自動平均分配', // 自動平均分配
	/**
* 門店信息
*/
'storeData_today_keliu': '今日客流', // 今日客流
'storeData_compare_yesterday': '對比昨日', // 對比昨日
'storeData_data_analyse': '數據分析', // 數據分析
'storeData_date_array': ['昨日','上週','上月','上季度','前日','上上週','上上月','上上季'], // 客流分析下拉框
'storeData_mingci': '名詞解釋', // 名詞解釋
'storeData_data_mingci_text': [ // 數據分析名詞解釋
'客流量：進入店舖的客流',
'銷售額：銷售額',
'訂單數：客戶購買的產生的小票數量',
'成交率：訂單數/客流量*100%',
'客單價：銷售總金額/訂單總數',
'連帶率：銷售商品總數量/訂單總數*100%',
'件單價：銷售總額/銷售商品總數量',
],
'storeData_month_xiaolv': '月門店效率', // 月門店效率
'storeData_month_mingci_text': [ // 月門店效率名詞解釋
'人效：銷售額/門店員工數量',
'坪效：銷售額/門店面積'
	],
'storeData_title_alarm': '告警信息', // 告警信息
'storeData_subtitle_alarm': '消息列表', // 消息列表
'storeData_alert_mes': '了解更多數據指標，請聯繫管理員進行門店經緯度，店員數量，門店面積數據配置。 ',
'storeData_jingweidu': '經緯度', // 經緯度
'storeData_mianji': '面積',
'storeData_renyuan': '人員',
'storeData_alert_config': '門店{mes}未配置',
	/**
* 區域數據
*/
'areaData_select_area': '選擇區域', // 選擇區域
'areaData_analyse': '門店分析', // 門店分析
'areaData_choose_time': '時間選擇', // 時間選擇
'areaData_jiejiahuodong': '節假日/活動日', // 節假日/活動日
'areaData_huodong': '活動日', // 活動日
'areaData_huanbi': '環比', // 環比
	/**
* 銷售排行
*/
'saleRank_datetype_list': [ // 銷售排行頭部時間切換
{value: 1, label: '門店日排名'},
    {value: 3, label: '門店月排名'},
    {value: 4, label: '門店季度排名'},
],
'saleRank_rank': '排名', // 表格頭column
'saleRank_store': '門店', // 表格頭column    =
	/**
* 排名
*/
'rank_title': '{name}排名', // 排名title
'rank_find_detail_btn': '查看詳細排名', // 查看詳細排名按鈕文字
/**
* 告警
*/
'alarm_all_store': '全部門店', // 全部門店
'alarm_jibie': '級別', // 級別
	/**
* 加載頁
*/
'loading_wuquanxian': '您還沒有任何門店權限，請聯繫管理員開通後使用本功能', // 加載頁無權限時顯示
/**
* 門店銷售情況
*/
'sale_store_detail': '門店主頁', // 門店主頁
'sale_today_title': '今日{name}', // 今日+name組成的title
'sale_compare_lastday': '對比昨日', // 對比昨日
'sale_the_month_xiaoshoue': '月累計銷售額', // 月累計銷售額
'sale_last_month_xiaoshoue': '上月累計銷售額', // 上月累計銷售額
'sale_qushi': '{name}趨勢', // 趨勢
'sale_pingjun': '平均水平', // 平均水平
'sale_tongbi': '同比', // 同比
'sale_click_more': '點擊加載更多', // 點擊加載更多
'sale_has_all_mes': '已加載全部數據', // 已加載全部數據
'sale_jiejiari_compare': '節假日對比', // 節假日對比
'sale_month_no_jiejiari': '本月無節假日', // 本月無節假日
'sale_store_rank': '本店{name}排名', // 本店排名
'sale_detail_rank': '詳細排名', //詳細排名
'sale_mingci': '名次', // 名次
	/**
* 選擇門店
*/
'chooseStore_select_store': '選擇門店', // 選擇門店
'chooseStore_cancel': '取消', // 取消
'chooseStore_search': '搜索', // 搜索
}